import { render, staticRenderFns } from "./PaiementTag.vue?vue&type=template&id=41332a09"
import script from "./PaiementTag.vue?vue&type=script&lang=js"
export * from "./PaiementTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports